import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = { "clip-path": "url(#clip0_906_1402)" }
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_906_1402" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1)

import { withDefaults } from 'vue'
import IconSvgWrap from './IconSvgWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCircleSubtraction',
  props: {
    fillColor: { default: '#F85359' },
    size: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { fillColor: string, size: number };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconSvgWrap, {
    size: props.size
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("svg", {
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("g", _hoisted_2, [
          _createElementVNode("path", {
            d: "M8.00016 14.6666C11.6821 14.6666 14.6668 11.6819 14.6668 7.99998C14.6668 4.31808 11.6821 1.33331 8.00016 1.33331C4.31826 1.33331 1.3335 4.31808 1.3335 7.99998C1.3335 11.6819 4.31826 14.6666 8.00016 14.6666Z",
            stroke: props.fillColor,
            "stroke-width": "1.5",
            "stroke-linejoin": "round"
          }, null, 8, _hoisted_3),
          _createElementVNode("path", {
            d: "M5.3335 8H10.6668",
            stroke: props.fillColor,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _hoisted_4)
        ]),
        _hoisted_5
      ], 8, _hoisted_1))
    ]),
    _: 1
  }, 8, ["size"]))
}
}

})